export function appendAttribute(permission, attribute) {
  return `${permission}.${attribute}`;
}
